<template>
  <div style="background-color: white">
    <div style="font-family: 'Noto Sans SC'">
      <div style="text-align: left;padding-left: 5vw"><img style="margin-top: 15px;width: 20vw" src="../assets/homtran_logo.png"></div>
      <div class="banner"><h2 style="color: #fff;">成为世界级的跨境电商百年企业</h2></div>
      <div style="display: flex;justify-content: space-between;margin: 10px 15px;background-color: white">

        <div style="font-size: large;font-weight: bold;color: white;display:inline-flex;flex-direction: column;justify-content: space-between;width: 49%;height: 70vw">

          <a style="height: 33%" href="http://www.homtran.com/index.php?m=home&c=Lists&a=index&tid=1"><div class="aboutBs_icon" :style="`background: url(${require('../assets/aboutBg.png')}) 0% 0% / cover no-repeat`" style="letter-spacing: 0.5vw;font-size: 4vw;display: flex;justify-content: center;align-items: center;box-shadow: rgb(98, 96, 96) 2px 4px 10px 0;border-radius: 10px;height: 100%;">
            关于斯罗克</div></a>

          <a style="height: 63%" href="http://www.homtran.com/qa.html"><div class="QA_bg_icon" :style="`background: url(${require('../assets/QA_bg.png')}) 0% 0% / cover no-repeat`" style="display: flex;justify-content: center;align-items: center;box-shadow: rgb(98, 96, 96) 2px 4px 10px 0;border-radius: 10px;height: 100%;letter-spacing: 0.5vw;font-size: 4vw;">
            QA</div></a>

        </div>

        <div style="font-size: large;font-weight: bold;color: white;display:inline-flex;flex-direction: column;justify-content: space-between;width: 49%;height: 70vw">
          <div @click="$router.push({path:'/develop/homtran'})" :style="`background: url(${require('../assets/developBg.png')}) 0% 0% / cover no-repeat`" style="display: flex;justify-content: center;align-items: center;box-shadow: rgb(98, 96, 96) 2px 4px 10px 0;border-radius: 10px;height: 63%">
            <a style="letter-spacing: 0.5vw;font-size: 4vw;" class="develop_icon">培养发展</a>
          </div>
          <div @click="$router.push({path:'/welfare/homtran'})" :style="`background: url(${require('../assets/socailBg.png')}) 0% 0% / cover no-repeat`" style="display: flex;justify-content: center;align-items: center;box-shadow: rgb(98, 96, 96) 2px 4px 10px 0;border-radius: 10px;height: 33%">
            <a style="letter-spacing: 0.5vw;font-size: 4vw;" class="welfare_icon">公司福利</a>
          </div>
        </div>

      </div>
      <div style="display: flex;justify-content: space-between;margin: 10px 15px;background-color: white">

        <div style="font-size: large;font-weight: bold;color: white;display:inline-flex;flex-direction: column;justify-content: space-between;width: 49%;height: 70vw">

          <div @click="$router.push({path:'/recruit/homtran'})" :style="`background: url(${require('../assets/aboutBg.png')}) 0% 0% / cover no-repeat`" style="display: flex;justify-content: center;align-items: center;box-shadow: rgb(98, 96, 96) 2px 4px 10px 0;border-radius: 10px;height: 33%">
            <a style="letter-spacing: 0.5vw;font-size: 4vw;" class="process_icon">招聘流程</a>
          </div>

          <div @click="$router.push({path: '/list/homtran', query: {recruitmentChannels : '2'}})" :style="`background: url(${require('../assets/QA_bg.png')}) 0% 0% / cover no-repeat`" style="display: flex;justify-content: center;align-items: center;box-shadow: rgb(98, 96, 96) 2px 4px 10px 0;border-radius: 10px;height: 63%">
            <a style="letter-spacing: 0.5vw;font-size: 4vw;" class="internal_icon">内部推荐</a>
          </div>
        </div>

        <div style="font-size: large;font-weight: bold;color: white;display:inline-flex;flex-direction: column;justify-content: space-between;width: 49%;height: 70vw">
          <div @click="$router.push({path: '/list/homtran', query: {recruitmentChannels : '3'}})" :style="`background: url(${require('../assets/developBg.png')}) 0% 0% / cover no-repeat`" style="display: flex;justify-content: center;align-items: center;box-shadow: rgb(98, 96, 96) 2px 4px 10px 0;border-radius: 10px;height: 63%">
            <a style="letter-spacing: 0.5vw;font-size: 4vw;" class="school_icon">校园招聘</a>
          </div>
          <div @click="$router.push({path: '/list/homtran', query: {recruitmentChannels : '1'}})" :style="`background: url(${require('../assets/socailBg.png')}) 0% 0% / cover no-repeat`" style="display: flex;justify-content: center;align-items: center;box-shadow: rgb(98, 96, 96) 2px 4px 10px 0;border-radius: 10px;height: 33%">
            <a style="letter-spacing: 0.5vw;font-size: 4vw;" class="society_icon">社会招聘</a>
          </div>
        </div>

      </div>

      <div style="color: white;background-size:100% 100%;background-blend-mode: multiply;background-color: gray;display: flex;flex-direction: column;justify-content: space-around;align-items: center;width: 100%;height: 17vw" :style="{backgroundImage:`url(${bottomBG})`}">
        <p style="letter-spacing: 1.5vw;font-size: 3.5vw">联系我们</p>
        <p class="phone_icon" style="letter-spacing: 0.5vw;font-size: 3vw;margin-right: 2vw;display: flex;justify-content: space-around;align-items: center">0755-28682894</p>
        <p class="location_icon" style="letter-spacing: 0.5vw;font-size: 3vw;margin-top: -0.5vw;display: flex;justify-content: space-around;align-items: center">深圳市龙岗区横岗街道办埔夏路53号一栋一楼</p>
      </div>

    </div>
  </div>

</template>

<script>

import {Swiper, SwiperSlide, directive} from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import {INTRODUCE} from '../const'
import bottomBG from '../assets/bottomBG.jpg'

export default {
  name: "Advertisement4Kingsold",
  components: {
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  data() {
    return {
      bottomBG:bottomBG,
      dynamicWidth: window.innerWidth,
      introduce: INTRODUCE,
      swiperOptions: {
        // Some Swiper option/callback...
        loop: true,
        autoplay: {
          autoplayDisableOnInteraction: false,
          disableOnInteraction: false,
        },
      }
    }
  },

  computed: {
    swiper() {
      return this.$refs.mySwiper ? this.$refs.mySwiper.$swiper : null;
    }
  },
  mounted() {
    this.swiper && this.swiper.slideTo(3, 1000, false);
  },
}
</script>

<style scoped>

a {
  color: white;
  cursor: none;
  text-decoration: none;
}

* {
  margin: 0;
  padding: 0;
}

.banner {
  width: 100%;
  margin: 0 auto;
  position: relative;
}

.banner img {
  width: 100%;
  display: block;
}


.phone_icon:before{
  content:"";
  background:url(../assets/phone_icon_white.png) no-repeat;
  background-size: 3vw;
  width:3vw;
  height:3vw;
  position: relative;
  left: -1vw;
}
.location_icon:before{
  content:"";
  background:url(../assets/locate.png) no-repeat;
  background-size: 3vw;
  width:3vw;
  height:3vw;
  position: relative;
  left: -1vw;
}
.aboutBs_icon:before{
  content:"";
  background:url(../assets/about_icon.png) no-repeat;
  background-size: 4vw;
  width:4vw;
  height:4vw;
  position: relative;
  left: -2vw;
  top: 0.5vw;
  display: inline-block;
}

.QA_bg_icon:before{
  content:"";
  background:url(../assets/QA_icon.png) no-repeat;
  background-size: 4vw;
  width:4vw;
  height:4vw;
  position: relative;
  left: -2vw;
  top: 0.5vw;
  display: inline-block;
}

.welfare_icon:before{
  content:"";
  background:url(../assets/welfare_icon.png) no-repeat;
  background-size: 4vw;
  width:4vw;
  height:4vw;
  position: relative;
  left: -2vw;
  top: 0.5vw;
  display: inline-block;
}
.develop_icon:before{
  content:"";
  background:url(../assets/develop_icon.png) no-repeat;
  background-size: 4vw;
  width:4vw;
  height:4vw;
  position: relative;
  left: -2vw;
  top: 0.5vw;
  display: inline-block;
}
.process_icon:before{
  content:"";
  background:url(../assets/process_icon.png) no-repeat;
  background-size: 4vw;
  width:4vw;
  height:4vw;
  position: relative;
  left: -2vw;
  top: 0.5vw;
  display: inline-block;
}

.internal_icon:before{
  content:"";
  background:url(../assets/internal_icon.png) no-repeat;
  background-size: 4vw;
  width:4vw;
  height:4vw;
  position: relative;
  left: -2vw;
  top: 0.5vw;
  display: inline-block;
}

.school_icon:before{
  content:"";
  background:url(../assets/school_icon.png) no-repeat;
  background-size: 4vw;
  width:4vw;
  height:4vw;
  position: relative;
  left: -2vw;
  top: 0.5vw;
  display: inline-block;
}

.society_icon:before{
  content:"";
  background:url(../assets/social_icon.png) no-repeat;
  background-size: 4vw;
  width:4vw;
  height:4vw;
  position: relative;
  left: -2vw;
  top: 0.5vw;
  display: inline-block;
}

.banner{
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 50vw;
  background-blend-mode: multiply;
  background-color: gray;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url(../assets/banner_homtran_bg.jpg);
}

</style>
